import getIdFromIdIri from '../../shared/parsers/getIdFromIdIri';

function subscriptionParser(datas: any): SubscriptionParserResult {
  const parsedSubscription: ISubscription = {
    idIri: datas['@id'],
    id: getIdFromIdIri(datas['@id']),
    price: datas.price,
    hasActiveResearch: datas.has_active_research,
    hasComparativeStudy: datas.has_comparative_study,
    hasGeolocation: datas.has_geolocation,
    hasMarketResearch: datas.has_market_research,
    hasRequest: datas.has_request,
    totalAuthorizedUsers: datas.total_authorized_users,
    subscriptionDemands: datas.subscription_demands,
  };
  const subscriptionsDemands = datas.subscription_demands ?? [];
  const cities = citiesParser(datas.cities);
  const departments = departmentsParser(datas.departments);

  return {
    subscription: parsedSubscription,
    cities,
    departments,
    subscriptionsDemands,
  };
}

function cityParser(data: any): ICity {
  const nameAndDepNumber = `${data.name} ${
    data.zip_code ? '(' + data.zip_code + ')' : ''
  }`;

  const coordinates =
    data.latitude && data.longitude
      ? { lat: data.latitude, lng: data.longitude }
      : null;

  const parsed: ICity = {
    idIri: data['@id'],
    id: getIdFromIdIri(data['@id']),
    name: data.name,
    postalCode: data.zip_code ?? null,
    inseeCode: data.insee_code ?? null,
    nameAndDepNumber,
    coordinates,
  };

  return parsed;
}
function citiesParser(datas: any[]): Cities {
  if (!datas) return [];
  return datas.map((m: any) => cityParser(m));
}

function departmentParser(data: any): IDepartment {
  const parsed: IDepartment = {
    idIri: data['@id'],
    id: getIdFromIdIri(data['@id']),
    code: data.code,
    name: data.name,
  };

  return parsed;
}
function departmentsParser(datas: any[]): Departments {
  if (!datas) return [];
  return datas.map((m: any) => departmentParser(m));
}

export { citiesParser, cityParser, subscriptionParser };
